





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import AccountComponent from '@/components/AccountComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { TokenUser } from '@/TokenUser'

@Component({
  name: 'AccountLookup',
  components: { AccountComponent }
})

export default class AccountLookupComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public usernameOrAddress: string = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }

  public async onSubmit() {
    if (this.usernameOrAddress) {
      // easter egg for dapper mode
      if (this.usernameOrAddress.startsWith('!')) {
        if (this.usernameOrAddress.includes(utils_topshot.dmTrigger) && this.usernameOrAddress.endsWith('on')) {
          if (this.user) {
            utils_topshot.setDapperMode(true)
            this.$store.commit("setNavBarMessage", { navBarMessage: 'Dapper Admin' });
            utils_tracker.track('Enabled Dapper', { email: this.user.email })
            this.$router.go(0);
          } else {
            utils.toast(this, 'Error', `You must be logged in to enable Dapper mode.`)
          }
        } else {
          utils_topshot.setDapperMode(false)
          this.$store.commit("setNavBarMessage", { navBarMessage: null });
          this.$router.go(0);
        }
      } else {
        await (this.$refs.AccountComponent as AccountComponent).setUsernameOrFlowAddress(this.usernameOrAddress)
      }
    }
  }

  // private, non-reactive member variables

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`AccountLookupComponent.pathChanged() ${this.$route.path}`)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    await this.pathChanged()

    // from url
    if (this.$route.query.address) this.usernameOrAddress = this.$route.query.address as string

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

  }

}
